<template>
  <div :class="['gam-counter']">
    <div :class="['gam-counter-container', getContainerClasses]">
      <div v-if="label" class="label">
        {{ localize(label) }}
      </div>

      <div class="some-container">
        <div class="some">Some</div>

        <GamIcon class="plus" :name="GamIconName.PLUS" @click="handleIncrement" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { localize } from '@/core/gambits';
import { GamComponentsEmits } from '@/views/composables/constants/main/emit.constants';
import type { GamCounterType } from '@/views/composables/models/components/GamCounter';
import { computed, onMounted, ref, watch } from 'vue';
import { GamIconName } from '../composables/constants/components/gamIcon.constants';
import GamIcon from './GamIcon.vue';

const props = withDefaults(defineProps<GamCounterType>(), {
  value: 0,
});
const emits = defineEmits([GamComponentsEmits.UPDATE_VALUE]);

const inputCounter = ref<number | string>(props.value);

function handleIncrement() {
  inputCounter.value = 1;
}

onMounted(() => {
  emits(GamComponentsEmits.UPDATE_VALUE, inputCounter.value);
});

const getContainerClasses = computed(() => ({
  'is-disabled': props.isDisabled,
  'is-error': props.isError,
  'read-only': props.readOnly,
}));

watch(inputCounter, (value) => {
  emits(GamComponentsEmits.UPDATE_VALUE, value);
});
</script>

<style lang="scss" scoped>
@use '@/ui/css/mixins' as *;
@use '@/ui/css/partial';

.gam-counter {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  .some-container {
    height: 50px;
  }

  .some-container {
    border-radius: var(--radius-large);
    height: 50px !important;
    width: 120px;
    box-sizing: border-box;
    cursor: text;
    border: 1px solid var(--color-white-5);
    transition: border var(--transition);
    position: relative;
    @extend %gam-special-border;
    background-color: rgba(24, 23, 22, 0.33);
    -webkit-backdrop-filter: blur(15px);
    backdrop-filter: blur(15px);
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-indent: 24px;

    &:before {
      background: var(--color-linear-gradient);
      opacity: 0;
      inset: -1px;
    }

    @include hover {
      &:before {
        opacity: 1;
      }
    }
  }

  .plus {
    position: absolute;
    top: 50%;
    right: 13px;
    transform: translateY(calc(-50% - 2px));
    cursor: pointer;
  }

  .gam-counter-container {
    width: inherit;
    display: flex;
    align-items: center;
    padding: 0;
    border-radius: var(--radius-large);
    height: auto;
    position: relative;
    transition: opacity var(--transition-fast);
    gap: 16px;

    .label {
      width: inherit;
      position: relative;
      font-size: 16px;
      font-weight: 300;
      color: var(--color-white-100);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre;
    }

    .icon {
      display: block;
      align-items: center;
      justify-content: center;
    }

    .input-count {
      min-width: 120px;
    }

    &.is-disabled {
      cursor: default;
      -webkit-user-select: none;
      user-select: none;
      pointer-events: none;
      opacity: 0.3;
    }
  }
}
</style>
